import { SVGProps } from 'react';
const SVGDownBoldChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} fill="none" {...props}>
    <path
      fill="#8A92A6"
      d="M9.227 2H.771C.085 2-.258 2.91.228 3.445l3.7 4.066a1.427 1.427 0 0 0 2.15 0l1.406-1.546 2.293-2.52C10.256 2.91 9.913 2 9.227 2Z"
    />
  </svg>
);
export default SVGDownBoldChevron;
